<template>
  <Layout>
    <!-- Start Service Area -->
    <section class="rn-service-area rn-section-gap">
      <div class="container">
        <div class="row row--30">
          <div class="col-lg-12">
            <SectionTitle
              class="mb--50"
              text-align="center"
              subtitle="Where People and Technology Intersect"
              title="Serving the Needs of Our Clients"
              data-aos="fade-up"
              data-aos-delay="60"
            />
          </div>
        </div>
        <div class="row row--15 service-wrapper">
          <div class="col-12">
            <ServiceCard
              :service="{
                  icon: 'map',
                  id: 'growth-navigation',
                  title: 'Growth Navigation',
                  description: '<p>We work alongside your teams to improve delivery, strengthen structure, and build the capabilities your organization needs to scale—without adding new layers of leadership or long-term dependency.</p><h2>What We Help You Do</h2><ul><li>Implement the highest-impact improvements from your assessment</li><li>Improve delivery flow and team collaboration</li><li>Clarify roles, responsibilities, and team structure</li><li>Equip managers and leads with practical leadership skills</li><li>Introduce sustainable processes that reduce chaos and increase predictability</li><li>Navigate organizational change with confidence</li></ul><h2>How We Engage</h2><p>A collaborative monthly partnership focused on hands-on support, workshops, and regular working sessions with your engineering and product leadership. Tailored to your goals, your pace, and your team\'s operating environment.</p><h2>The Outcome</h2><p>A more aligned, more capable engineering organization—delivering faster, communicating more clearly, and operating with systems that support growth instead of hindering it.</p>'
              }"
              :service-style="`service__style--1 bg-color-blackest radius mt--25`"
              :icon-size="62"
              text-align="left"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- End Service Area -->

  </Layout>
</template>

<script>
    import Layout from '../../components/common/Layout'
    import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
    import ServiceCard from '../../components/elements/service/ServiceCard'

    export default {
        name: 'GrowthNavigation',
        components: {Layout, SectionTitle, ServiceCard},
    }
</script>
